module.exports = __webpack_public_path__ + "static/media/delete-block-composer.32c0a817.svg";